// extracted by mini-css-extract-plugin
module.exports = {"section":"K_section__A5ox0"};